import type { SharedValue } from "react-native-reanimated";
import { useAppTheme } from "../../useAppTheme";
import { WaveformVisualizer } from "../WaveformVisualizer";

type Props = {
	uri: string;
	progress: number;
	progressShared?: SharedValue<number>;
	onSeek: (progress: number) => Promise<void>;
	waveformWidth?: number;
	updateWaveformWidth?: (width: number) => void;
	useReanimated: boolean;
	canSeek: boolean;
};

const PlayerWave = ({
	uri,
	progress,
	progressShared,
	onSeek,
	waveformWidth,
	updateWaveformWidth,
	useReanimated,
	canSeek,
}: Props) => {
	const theme = useAppTheme();
	return (
		<WaveformVisualizer
			showWaveform
			progress={progress}
			progressShared={progressShared}
			onSeek={onSeek}
			uri={uri}
			activeColor={theme.colors.primary}
			inactiveColor={theme.colors.outline}
			maxHeight={24}
			waveformWidth={waveformWidth}
			updateWaveformWidth={updateWaveformWidth}
			useReanimated={useReanimated}
			canSeek={canSeek}
			cursor={canSeek ? "grab" : "default"}
		/>
	);
};

export default PlayerWave;
